import { jsxs, jsx } from "@emotion/react/jsx-runtime";
import { ThemeProvider as ThemeProvider$1, FontLoader, INSTACART_SANS_FONT_FAMILY, InstacartSansFontLoaderVariants } from "./auth-service-tools24.js";
import { GlobalStyles } from "./auth-service-tools3.js";
import { breakpoints } from "./auth-service-tools102.js";
import "./auth-service-tools106.js";
import "./auth-service-tools107.js";
import "./auth-service-tools108.js";
import { TdsProvider, enUSTranslations } from "./auth-service-tools98.js";
import { MantineProvider } from "./auth-service-tools109.js";
import { colors } from "./auth-service-tools26.js";
const themeOverrides = {
  fontFamily: `'${INSTACART_SANS_FONT_FAMILY}'`,
  colors: {
    brand: [colors.PRIMARY.REGULAR, colors.PRIMARY.DARK, colors.PRIMARY.EXTRA_DARK]
  },
  ...breakpoints,
  respectReducedMotion: false,
  primaryColor: "brand",
  primaryShade: 0,
  components: {
    // See (v7) Mantine docs https://mantine.dev/styles/styles-api/#classnames-in-themecomponents
    // We apply classNames defined in GlobalStyles to components to override Mantine's default styles
    DatePicker: {
      classNames: {
        calendarHeader: "internal-mantine-Calendar-calendarHeader",
        calendarHeaderLevel: "internal-mantine-Calendar-calendarHeaderLevel",
        monthCell: "internal-mantine-Calendar-monthCell",
        month: "internal-mantine-Calendar-month",
        yearsListControl: "internal-mantine-Calendar-yearPickerControl",
        monthsListControl: "internal-mantine-Calendar-monthPickerControl",
        day: "internal-mantine-Calendar-day",
        weekday: "internal-mantine-Calendar-weekday"
      },
      defaultProps: {
        weekendDays: []
      }
    },
    DateInput: {
      classNames: {
        calendarHeader: "internal-mantine-Calendar-calendarHeader",
        calendarHeaderLevel: "internal-mantine-Calendar-calendarHeaderLevel",
        monthCell: "internal-mantine-Calendar-monthCell",
        month: "internal-mantine-Calendar-month",
        yearsListControl: "internal-mantine-Calendar-yearPickerControl",
        monthsListControl: "internal-mantine-Calendar-monthPickerControl",
        day: "internal-mantine-Calendar-day",
        weekday: "internal-mantine-Calendar-weekday"
      },
      defaultProps: {
        weekendDays: []
      }
    },
    Popover: {
      defaultProps: {
        shadow: "md",
        withinPortal: true
      },
      classNames: {
        dropdown: "mantine-Popover-dropdown"
      }
    }
  }
};

const ThemeProvider = (_ref) => {
  let {
    children
  } = _ref;
  return /* @__PURE__ */jsxs(ThemeProvider$1, {
    children: [/* @__PURE__ */jsx(FontLoader, {
      fontFamily: INSTACART_SANS_FONT_FAMILY,
      variants: InstacartSansFontLoaderVariants
    }), /* @__PURE__ */jsxs(TdsProvider, {
      i18nProps: {
        dictionary: enUSTranslations,
        locale: "en"
      },
      children: [/* @__PURE__ */jsx(GlobalStyles, {}), /* @__PURE__ */jsx(MantineProvider, {
        theme: themeOverrides,
        children
      })]
    })]
  });
};

export { ThemeProvider };